import { render, staticRenderFns } from "./ReviewPartnerManufacturerShowcases.vue?vue&type=template&id=84fcc416&"
import script from "./ReviewPartnerManufacturerShowcases.vue?vue&type=script&lang=js&"
export * from "./ReviewPartnerManufacturerShowcases.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports